import { ICatalogListingBookingQuery } from '../interfaces/catalog-listing-booking.query.interface';

export class CatalogListingBooking {
    id: string;
    status: string;
    listingId: string;
    requesterComment: string | null;
    canCancel: boolean;
    createdAt: string;

    constructor(query: ICatalogListingBookingQuery) {
        this.id = query.id.toString();
        this.status = query.status;
        this.listingId = query.listing?.id?.toString() || '';
        this.requesterComment = query.requester_comment ?? null;
        this.canCancel = !!query.can_cancel;
        this.createdAt = query.created_at;
    }
}
